import styled from 'styled-components';
import { campoBase, rotuloFlutuante, rotuloFlutuanteAtivo } from '../../styles/campo';

export const Container = styled.div`
  position: relative;
  width: 100%;

  select {
    ${campoBase}
    appearance: none;
    padding-right: 36px;
    cursor: pointer;

    /* :read-only do campoBase também pega o select, que não tem readonly: volta ao visual editável */
    &:read-only {
      background-color: ${({ theme }) => theme.cores.card};
      color: ${({ theme }) => theme.cores.ink};
      cursor: pointer;
    }

    &:read-only:hover {
      border-color: ${({ theme }) => theme.cores.borderStrong};
    }

    &:read-only:focus {
      border-color: ${({ theme }) => theme.cores.primary};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.cores.foco};
    }
  }

  /* o select sempre tem valor: o rótulo fica em cima */
  label {
    ${rotuloFlutuante}
    ${rotuloFlutuanteAtivo}
  }

  select:focus + label {
    color: ${({ theme }) => theme.cores.primary};
  }

  .seta {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    color: ${({ theme }) => theme.cores.inkSecondary};
    pointer-events: none;
  }

  .obrigatorio {
    color: ${({ theme }) => theme.cores.critical};
    margin-left: 2px;
  }
`;
